module.exports = __webpack_public_path__ + "img/STERiGLIDE_04_02.b61b45e3.jpg";